// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import { resetPromptsMock } from './__mocks__/@inquirer/prompts'
import { SyncTargetManager } from './commands/sync/syncTargetManager'

// Special reset function exported from the manual mock (__mocks__/fs.ts)
// Must be imported via 'fs' and not the mock or there are actually 2 copies
import { resetMockFs } from 'fs'

jest.mock('fs')
jest.mock('./retool_client')
// The buffered stream used by the inquirer/testing package
// reports a cli width of 80, which causes the inquirer package
// to insert line breaks which cause inconsistency in snapshots
// based on the environments they're run in.
// Setting this environment variable to a high number causes no automatic wrapping to occur
process.env['CLI_WIDTH'] = '100000'

global.beforeEach(() => {
  SyncTargetManager.reset()

  resetPromptsMock()
  resetMockFs()
})

// Needed so tests can pass in Node v16 which is what runs in CI
if (!('Blob' in globalThis)) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  globalThis.Blob = require('node:buffer').Blob
}
